import * as MailRowDataPropertyGetter from '../selectors/mailRowDataPropertyGetter';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import loc from 'owa-localize';
import { noSubject } from 'owa-locstrings/lib/strings/nosubject.locstring.json';
import getSelectedTableView from './getSelectedTableView';
import type { MailListRowDragData } from 'owa-mail-types/lib/types/MailListRowDragData';
import isConversationView from './isConversationView';

export default function getMailListRowDragData(): MailListRowDragData {
    // Also rename this to getMailListRowDragData. May be get this information from the mailRowData getter api
    const tableView = getSelectedTableView();
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS7034 (15,11): Variable 'latestItemIds' implicitly has type 'any[]' in some locations where its type cannot be determined.
    // @ts-expect-error
    const latestItemIds = [];
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS7034 (19,11): Variable 'subjects' implicitly has type 'any[]' in some locations where its type cannot be determined.
    // @ts-expect-error
    const subjects = [];
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS7034 (23,11): Variable 'sizes' implicitly has type 'any[]' in some locations where its type cannot be determined.
    // @ts-expect-error
    const sizes = [];
    const selectedRowKeys = [...tableView.selectedRowKeys.keys()];
    const itemType =
        selectedRowKeys.length > 1
            ? isConversationView(tableView)
                ? DraggableItemTypes.MultiMailListConversationRows
                : DraggableItemTypes.MultiMailListMessageRows
            : DraggableItemTypes.MailListRow;

    selectedRowKeys.forEach(rowKey => {
        const subject = MailRowDataPropertyGetter.getSubject(rowKey, tableView);
        subjects.push(subject ? subject : loc(noSubject));

        const size = MailRowDataPropertyGetter.getSize(rowKey, tableView);
        sizes.push(size ? size : 0);

        const itemIds = MailRowDataPropertyGetter.getItemIds(rowKey, tableView);
        if (itemIds) {
            latestItemIds.push(itemIds[0]);
        }
    });

    return {
        itemType: itemType,
        tableViewId: tableView.id,
        tableListViewType: tableView.tableQuery.listViewType,
        rowKeys: selectedRowKeys,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS7005 (53,19): Variable 'subjects' implicitly has an 'any[]' type.
        // @ts-expect-error
        subjects: subjects,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS7005 (57,24): Variable 'latestItemIds' implicitly has an 'any[]' type.
        // @ts-expect-error
        latestItemIds: latestItemIds,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS7005 (61,16): Variable 'sizes' implicitly has an 'any[]' type.
        // @ts-expect-error
        sizes: sizes,
    };
}
